// extracted by mini-css-extract-plugin
export var label = "_gz-0";
export var treatmentCard = "_gz-1";